// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
/**
 * 
 * @export
 * @interface RegistryBasic
 */
export interface RegistryBasic {
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof RegistryBasic
     */
    name?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof RegistryBasic
     */
    gender?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof RegistryBasic
     */
    status?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof RegistryBasic
     */
    lastName?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof RegistryBasic
     */
    firstName?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof RegistryBasic
     */
    middleName?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof RegistryBasic
     */
    credential?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof RegistryBasic
     */
    namePrefix?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof RegistryBasic
     */
    nameSuffix?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof RegistryBasic
     */
    lastUpdated?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof RegistryBasic
     */
    soleProprietor?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof RegistryBasic
     */
    enumerationDate?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof RegistryBasic
     */
    certificationDate?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof RegistryBasic
     */
    aoTitle?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof RegistryBasic
     */
    orgName?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof RegistryBasic
     */
    aoLastName?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof RegistryBasic
     */
    aoFirstName?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof RegistryBasic
     */
    aoTeleNumber?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof RegistryBasic
     */
    orgSubpart?: string;
}

export function RegistryBasicFromJSON(json: any): RegistryBasic {
    return {
            'name': !exists(json, 'name') ? undefined : json['name'],
            'gender': !exists(json, 'gender') ? undefined : json['gender'],
            'status': !exists(json, 'status') ? undefined : json['status'],
            'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
            'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
            'middleName': !exists(json, 'middleName') ? undefined : json['middleName'],
            'credential': !exists(json, 'credential') ? undefined : json['credential'],
            'namePrefix': !exists(json, 'namePrefix') ? undefined : json['namePrefix'],
            'nameSuffix': !exists(json, 'nameSuffix') ? undefined : json['nameSuffix'],
            'lastUpdated': !exists(json, 'lastUpdated') ? undefined : json['lastUpdated'],
            'soleProprietor': !exists(json, 'soleProprietor') ? undefined : json['soleProprietor'],
            'enumerationDate': !exists(json, 'enumerationDate') ? undefined : json['enumerationDate'],
            'certificationDate': !exists(json, 'certificationDate') ? undefined : json['certificationDate'],
            'aoTitle': !exists(json, 'aoTitle') ? undefined : json['aoTitle'],
            'orgName': !exists(json, 'orgName') ? undefined : json['orgName'],
            'aoLastName': !exists(json, 'aoLastName') ? undefined : json['aoLastName'],
            'aoFirstName': !exists(json, 'aoFirstName') ? undefined : json['aoFirstName'],
            'aoTeleNumber': !exists(json, 'aoTeleNumber') ? undefined : json['aoTeleNumber'],
            'orgSubpart': !exists(json, 'orgSubpart') ? undefined : json['orgSubpart'],
    };

}

export function RegistryBasicToForm(value?: RegistryBasic): any {
    let jsonVal = RegistryBasicToJSON(value);
    let retVal = '';
    if(jsonVal !== undefined && jsonVal != null) {
        Object.keys(jsonVal).forEach((v, i) => {
            if(i > 0) retVal+= "&";
            retVal+= encodeURIComponent(v) + "=" + encodeURIComponent(jsonVal[v]);
        });
    }
    return retVal;
}

function cleanupBlankValuesForBackend(val?:any): any {
    if(val instanceof Array) {
        return (val as Array<any>).filter((val) => { return val !== undefined && val !== null && val !== ''});
    } else {
        return (val === '') ? null : val;
    }
}

export function RegistryBasicToJSON(value?: RegistryBasic): any {
    value = cleanupBlankValuesForBackend(value);
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
            'name': cleanupBlankValuesForBackend(value.name),
            'gender': cleanupBlankValuesForBackend(value.gender),
            'status': cleanupBlankValuesForBackend(value.status),
            'lastName': cleanupBlankValuesForBackend(value.lastName),
            'firstName': cleanupBlankValuesForBackend(value.firstName),
            'middleName': cleanupBlankValuesForBackend(value.middleName),
            'credential': cleanupBlankValuesForBackend(value.credential),
            'namePrefix': cleanupBlankValuesForBackend(value.namePrefix),
            'nameSuffix': cleanupBlankValuesForBackend(value.nameSuffix),
            'lastUpdated': cleanupBlankValuesForBackend(value.lastUpdated),
            'soleProprietor': cleanupBlankValuesForBackend(value.soleProprietor),
            'enumerationDate': cleanupBlankValuesForBackend(value.enumerationDate),
            'certificationDate': cleanupBlankValuesForBackend(value.certificationDate),
            'aoTitle': cleanupBlankValuesForBackend(value.aoTitle),
            'orgName': cleanupBlankValuesForBackend(value.orgName),
            'aoLastName': cleanupBlankValuesForBackend(value.aoLastName),
            'aoFirstName': cleanupBlankValuesForBackend(value.aoFirstName),
            'aoTeleNumber': cleanupBlankValuesForBackend(value.aoTeleNumber),
            'orgSubpart': cleanupBlankValuesForBackend(value.orgSubpart),
    };
}


